import { Heading, HeadingLevel } from "@ariakit/react";
import { cx } from "@indietabletop/appkit";
import { type ReactNode } from "react";
import { section } from "./style.css";

export function SectionContainer(props: { className?: string; children?: ReactNode }) {
  return (
    <HeadingLevel>
      <div {...cx(props, section.container)}>{props.children}</div>
    </HeadingLevel>
  );
}

export function SectionContent(props: { className?: string; children?: ReactNode }) {
  return <div {...cx(props, section.content)}>{props.children}</div>;
}

export function SectionHeading(props: { className?: string; children?: ReactNode }) {
  return <Heading {...cx(props, section.heading)}>{props.children}</Heading>;
}

export function SectionParagraph(props: { children: ReactNode; className?: string }) {
  return <p {...cx(props, section.paragraph)}>{props.children}</p>;
}
